"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentPolicyService = void 0;
const static_service_1 = require("@wix/static-service");
const definitions_1 = require("../definitions");
const consentPolicy_1 = require("../consentPolicy");
exports.ConsentPolicyService = (0, static_service_1.implementStaticService)(definitions_1.ConsentPolicyDefinition, ({ config, getService }) => {
    return (0, consentPolicy_1.createConsentPolicy)(config, getService);
});
//# sourceMappingURL=consentPolicyService.js.map